import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class TasksService {

  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /* Function get actiivity list */
  getTaskList(pageNumber): Observable<any> {
    const data = {
      'pageSize': 15,
      'pageNumber': pageNumber
    };
    return this.httpService.post(`activity/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to search actiivty */
  searchFilter(searchTerm: string): Observable<any> {
    const data = {
      'searchText': searchTerm
    };
    return this.httpService.post(`activity/search`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to delete activity */
  deleteTask(task: string, data: any): Observable<any> {
    return this.httpService.delete(`activity/${task}/${data.userObj.Empname}/${data.userObj.EmailID}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to update activity */
  updateTask(data: any): Observable<any> {
    return this.httpService.put(`activity`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to handle error data */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/tasks/tasks.service.ts